import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { ReactComponent as DownArrowIcon } from "../../../../../assets/appearencePage/arrow-down.svg";
import { ReactComponent as DownArrowIconDark } from "../../../../../assets/appearencePage/arrow-down-dark.svg";
import { ReactComponent as LockIcon } from "../../../../../assets/MainPage/addBlock/lock.svg";
import { ReactComponent as LockIconDark } from "../../../../../assets/MainPage/addBlock/lock-dark.svg";

import { ReactComponent as TextSvgIcon } from "../../../../../assets/appearencePage/text.svg";
import { ReactComponent as InfoIcon } from "../../../../../assets/appearencePage/info-circle.svg";
import { ReactComponent as LinkSvgIcon } from "../../../../../assets/appearencePage/link.svg";

import { ReactComponent as BrandingIcon } from "../../../../../assets/appearencePage/branding-white.svg";
import { ReactComponent as BrandingIconDark } from "../../../../../assets/appearencePage/branding-white-dark.svg";
import { ReactComponent as BrandingBW } from "../../../../../assets/appearencePage/branding-black.svg";
import { ReactComponent as BrandingBWDark } from "../../../../../assets/appearencePage/branding-black-dark.svg";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { createBrandingSettings } from "../../../../../redux/slices/appearance/createBrandingSettingSlice";
import {
  gettingSettingUpdataData,
  getScreenPreviewSetting,
} from "../../../../../redux/slices/appearance/appearanceSlice";
import { useNavigate } from "react-router-dom";
import useLocales from "../../../../../hooks/useLocales";
import ExtraSmallFilledButton from "../../../../../components/common/buttons/ExtraSmallFilledButton";
import AppearanceDeleteButton from "../../../../../components/common/buttons/AppearanceDeleteButton";

const BrandingAcc = ({ brandingAccordion, setBrandingAccordionFun }) => {
  const { darkMode } = useSelector((state) => state.theme);
  const [subLoading, setSubLoading] = useState(false);
  const { translate } = useLocales();
  const schema = yup.object().shape({
    brandingToggle: yup.boolean().required("branding toggle is required"),
    brandingTitle: yup.string(),
    brandingUrl: yup
      .string()
      .test(
        "required",
        translate("cms.branding_url_required"),
        (val) => !!val.trim()
      )
      // .test("http", translate("link_URL_must_start"), (value) =>
      //   /^(http|https):\/\//i.test(value)
      // )
      .required(translate("cms.branding_url_required")),
  });

  const dispatch = useDispatch();

  const navigate = useNavigate();
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    if (width > 768) {
      navigate("/dashboard/appearance");
    }
    const sizeHandler = () => {
      setWidth(window.innerWidth);
      if (window.innerWidth > 768) {
        navigate("/dashboard/appearance");
      }
    };
    window.addEventListener("resize", sizeHandler);
    return () => {
      window.removeEventListener("resize", sizeHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),
  });

  const userId = JSON.parse(localStorage.getItem("user"))?.userid;
  const linkId = localStorage?.getItem("linkId");
  const user = {
    userData: userId,
    linkData: linkId,
  };

  const paymenetBlocks = useSelector(
    (state) => state?.paymentStripes?.getBlockByPlanId?.paymenet_blocks
  );
  const paidUserCheck = paymenetBlocks === 1;

  const submitHandler = async (data) => {
    const userId = JSON.parse(localStorage.getItem("user"))?.userid;
    const pageName = JSON.parse(localStorage.getItem("user"))?.twofactor
      ?.pageName;
    const linkId = localStorage?.getItem("linkId");

    const formData = {
      brandingStatus: data?.brandingToggle,
      brandingTitle: data?.brandingTitle,
      brandingUrl: data?.brandingUrl,
      userId: userId,
      linkId: linkId,
      isPaid: paymenetBlocks === 1 ? true : false,
    };

    setSubLoading(true);

    await dispatch(createBrandingSettings(formData)).then(() => {
      dispatch(gettingSettingUpdataData(user));
      dispatch(getScreenPreviewSetting(pageName));
    });
    setSubLoading(false);
  };

  const [deleteStylePending, setDeleteStylePending] = useState(false);

  const deleteHandler = async (data) => {
    const userId = JSON.parse(localStorage.getItem("user"))?.userid;
    const pageName = JSON.parse(localStorage.getItem("user"))?.twofactor
      ?.pageName;
    const linkId = localStorage?.getItem("linkId");
    const formData = {
      brandingStatus: "",
      brandingTitle: "",
      brandingUrl: "",
      userId: userId,
      linkId: linkId,
    };
    setDeleteStylePending(true);

    await dispatch(createBrandingSettings(formData)).then(() => {
      dispatch(gettingSettingUpdataData(user));
      dispatch(getScreenPreviewSetting(pageName));
    });

    setDeleteStylePending(false);
  };

  const LinkStyls = useSelector(
    (state) => state?.gettingAppearance?.gettingAppearance?.data?.response
  );

  useEffect(() => {
    LinkStyls?.map((item) => {
      if (item?.coloum_name === "branding") {
        const coloumValue = JSON.parse(item.coloum_value);
        setValue("brandingUrl", coloumValue?.brandingUrl);
        setValue("brandingTitle", coloumValue?.brandingTitle);
        setValue("brandingToggle", coloumValue?.brandingStatus);
      }
      return null;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [LinkStyls]);

  return (
    <div
      className={`dark:border-color_dark bg-light_bg_v5 dark:bg-dark-secondary rounded-[10px] ${
        brandingAccordion
          ? "px-[25px] py-[30px] border border-light_bg_v2"
          : "p-2 pr-[13px]"
      } `}
    >
      <form onSubmit={handleSubmit((data) => submitHandler(data))}>
        <div className="flex  gap-2 justify-between items-center cursor-pointer">
          <div
            // onClick={() => setBrandingAccordionFun(!brandingAccordion)}
            onClick={() => {
              if (paidUserCheck) {
                setBrandingAccordionFun(!brandingAccordion);
              }
            }}
            className={`${brandingAccordion ? "" : "p-[5px]"} `}
          >
            {brandingAccordion ? (
              darkMode ? (
                <BrandingBWDark />
              ) : (
                <BrandingBW />
              )
            ) : (
              <div
                style={{
                  boxShadow: `-2px 3px 7px #3ACE0155`,
                }}
                className={`p-2 h-[36px] w-[36px] rounded-lg bg-gradient-to-br from-[#3ACE01] to-[#36C300]`}
              >
                <BrandingIcon className={`h-full w-full`} />
              </div>
            )}
          </div>
          <div
            // onClick={() => setBrandingAccordionFun(!brandingAccordion)}
            onClick={() => {
              if (paidUserCheck) {
                setBrandingAccordionFun(!brandingAccordion);
              }
            }}
            className="text-small1 text-heading_color w-full"
          >
            {brandingAccordion ? (
              <p className="text-small1_bold text-dark_bg_v1 dark:text-color_v1_dark">
                {/* BRANDING */}
                {translate("appearance.branding_cap")}
              </p>
            ) : (
              <p className="text-small1 text-heading_color dark:text-color_v1_dark">
                {/* Branding */}
                {translate("appearance.branding")}
              </p>
            )}
          </div>
          <div className="flex gap-2">
            {brandingAccordion && (
              <div>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    {...register("brandingToggle")}
                    className="sr-only peer"
                  />
                  <div
                    className={`w-[29px] h-[15px] bg-gray-200 dark:bg-[#404040] rounded-full peer peer-checked:after:translate-x-[13.5px] peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-[11px] after:w-[11px] after:transition-all peer-checked:bg-green-600 ${
                      errors?.brandingToggle
                        ? "ring-1 ring-state_color_error bg-red-300 after:bg-state_color_error"
                        : ""
                    }`}
                  ></div>
                </label>
              </div>
            )}
            {brandingAccordion ? (
              <div
                // onClick={() => setBrandingAccordionFun(!brandingAccordion)}
                onClick={() => {
                  if (paidUserCheck) {
                    setBrandingAccordionFun(!brandingAccordion);
                  }
                }}
                className="text-xl cursor-pointer"
              >
                {darkMode ? (
                  <DownArrowIconDark className="rotate-180" />
                ) : (
                  <DownArrowIcon className="rotate-180" />
                )}
              </div>
            ) : (
              <div
                // onClick={() => setBrandingAccordionFun(!brandingAccordion)}
                onClick={() => {
                  if (paidUserCheck) {
                    setBrandingAccordionFun(!brandingAccordion);
                  }
                }}
                className="text-xl cursor-pointer"
              >
                {darkMode ? (
                  <>{paidUserCheck ? <DownArrowIconDark /> : <LockIconDark />}</>
                ) : (
                  <>{paidUserCheck ? <DownArrowIcon /> : <LockIcon />}</>
                )}
              </div>
            )}
          </div>
        </div>
        {errors.brandingToggle && (
          <div className="text-right">
            <small className="text-state_color_error text-small3 ">
              {errors?.brandingToggle?.message}
            </small>
          </div>
        )}

        {brandingAccordion && (
          <div className="mt-[30px]">
            <div className="relative ">
              <input
                type={"text"}
                {...register("brandingTitle")}
                className={`ps-[33px] bg-light_bg_v5 border text-heading_color text-small2 md:text-small1 rounded-md focus:placeholder:text-heading_color focus:outline-none block w-full p-[11px] px-[15px] py-[3px] dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark dark:bg-dark-secondary ${
                  errors?.brandingTitle
                    ? "border-state_color_error"
                    : "border-light_bg_v2 bg-transparent focus:border-font_light_color dark:border-color_dark focus:dark:border-font_color"
                }`}
                placeholder={translate("cms.enter_title")}
              />
              <div className="absolute start-[10px] inset-y-0 flex justify-center items-center cursor-pointer">
                <TextSvgIcon
                  className={`${
                    errors?.brandingTitle
                      ? "stroke-state_color_error"
                      : darkMode
                      ? "stroke-color_v1_dark"
                      : " stroke-heading_color"
                  }`}
                />
              </div>
            </div>
            {errors.brandingTitle && (
              <small className="text-state_color_error text-small3 ">
                {errors?.brandingTitle?.message}
              </small>
            )}
            <div className="flex mt-[7px] gap-[5px] items-center">
              <div className="flex justify-center items-center">
                <InfoIcon />
              </div>
              <div className="text-dark_bg_v5 dark:text-dark_bg_v5 text-small2">
                {/* Leave empty to have the default site branding. */}
                {translate("default_branding")}
              </div>
            </div>

            <div className="relative mt-[14px]">
              <input
                type={"text"}
                {...register("brandingUrl")}
                className={`ps-[33px] bg-light_bg_v5 border text-heading_color text-small2 md:text-small1 rounded-md  focus:outline-none block w-full p-[11px] px-[15px] py-[3px] dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark dark:bg-dark-secondary ${
                  errors?.brandingUrl
                    ? "border-state_color_error placeholder:text-state_color_error"
                    : "border-light_bg_v2 bg-transparent focus:border-font_light_color focus:placeholder:text-heading_color dark:border-color_dark focus:dark:border-font_color"
                }`}
                placeholder={translate("cms.enter_url")}
              />
              <div className="absolute start-[10px] inset-y-0 flex justify-center items-center cursor-pointer">
                <LinkSvgIcon
                  className={`${
                    errors?.brandingUrl
                      ? "stroke-state_color_error"
                      : darkMode
                      ? "stroke-color_v1_dark"
                      : "stroke-heading_color"
                  }`}
                />
              </div>
            </div>
            {errors.brandingUrl && (
              <small className="text-state_color_error text-small3 ">
                {errors?.brandingUrl?.message}
              </small>
            )}

            <div className="flex mt-[25px] items-center justify-end">
              <AppearanceDeleteButton
                isLoading={deleteStylePending}
                onClickHandler={deleteHandler}
              />

              <ExtraSmallFilledButton
                name={`${translate("biolink_title.save_cap")}`}
                buttonType={"submit"}
                isLoading={subLoading}
                classes={"ms-3"}
              />
            </div>
          </div>
        )}
      </form>
    </div>
  );
};

export default BrandingAcc;
